module.exports = __webpack_public_path__ + "img/download.f351c287.svg";